import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TbTextCaption } from "react-icons/tb";
import { AnimatedTabbar, AnimatedTabbarItem } from "../../components/AnimatedTabbar/AnimatedTabbar";
import { BiCog } from "react-icons/bi";
import CadastroContainer from "../../components/CadastroContainer/CadastroContainer";
import { MdOutlineAlternateEmail, MdOutlineCookie, MdWebhook } from "react-icons/md";
import { useAuth } from "../../contexts/auth";
import PartialFormClients from "../Clientes/FormClients/PartialFormClients";
import { FormSmtpConfig } from "../../components/FormSmtpConfig/FormSmtpConfig";
import ConsultaWebhooks from "../Webhooks/ConsultaWebhooks/ConsultaWebhooks";
import CadastroWebhooks from "../Webhooks/CadastroWebhooks/CadastroWebhooks";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import PageTitle from "../../components/PageTitle/PageTitle";

export function Configurations() {
   const { tab, page } = useParams();
   const { user } = useAuth();
   const [selectedTab, setSelectedTab] = useState(tab || "dados-cadastrais");
   const navigate = useNavigate();

   useEffect(() => {
      setSelectedTab(tab || "reception");
   }, [tab]);

   return (
      <CadastroContainer>
         <div className="reception-header">
            <div className="w-full">
               <div className="reception-header-upper-container">
                  <PageTitle
                     title={`Configurações de ${user?.userData?.selectedOrganization?.name}`}
                     icon={<BiCog size={23} />}
                  />
               </div>
               <div className="reception-header-lower-container">
                  <AnimatedTabbar
                     value={selectedTab}
                     className={`border-none!`}
                     onChange={value => navigate(`/configuracoes/${value}`)}
                  >
                     <AnimatedTabbarItem name="dados-cadastrais">
                        <span><TbTextCaption size={15} /></span>
                        <span>Dados cadastrais</span>
                     </AnimatedTabbarItem>
                     <AnimatedTabbarItem name="email">
                        <span><MdOutlineAlternateEmail size={15} /></span>
                        <span>Servidor de e-mail</span>
                     </AnimatedTabbarItem>
                     {/* <AnimatedTabbarItem name="webhooks/consulta">
                        <span><MdWebhook size={15} /></span>
                        <span>Webhooks</span>
                     </AnimatedTabbarItem>
                     <AnimatedTabbarItem name="sessions">
                        <span><HiOutlineDesktopComputer size={15} /></span>
                        <span>Sessões</span>
                     </AnimatedTabbarItem> */}
                  </AnimatedTabbar>
               </div>
            </div>
         </div>
         {selectedTab === "dados-cadastrais" && (
            <PartialFormClients type="edicao" client={user.userData?.selectedOrganization} />
         )}
         {selectedTab === "email" && (
            <FormSmtpConfig organization={user.userData?.selectedOrganization} />
         )}
         {selectedTab.includes("webhooks") && (
            <>
               {page === "consulta" && <ConsultaWebhooks />}
               {page === "cadastro" && <CadastroWebhooks />}
               {page === "webhooks/:webhookId" && <CadastroWebhooks />}
            </>
         )}
         {selectedTab === "sessions" && (
            <></>
         )}
      </CadastroContainer>
   );
}